import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  // Extract category and listingType for no-image placeholder
  const publicData = listing.attributes?.publicData || {};
  const category = publicData.categoryLevel1 || publicData.category;
  const listingType = publicData.listingType;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        category={category}
        listingType={listingType}
      />
    </section>
  );
};

export default SectionGallery;
